import React from "react";

// locales
import i18n from '../../i18n';
// the hoc
import { withTranslation } from 'react-i18next';

// components
import Autocomplete from "../autocomplete/Autocomplete";

// style
import "./SelectArtistTitle.scss";

class SelectArtistTitle extends React.Component {

    // constructor(props) {
    //     super(props);
    //     this._onclickHandler = props.onClick;
    //     this.state = {
    //         persons: [],
    //     };
    // }

    // ____________________________________ onHandlers ____________________________________

    // onRadioChangeHandler(e) {
    //     const id = e.currentTarget.id;
    //     this.setState({
    //         radioBtnState: id,
    //     });
    // }

    // onSubmitHandler() {
    //     console.log('xxxxxxxxxxxxxx');
    //     this._onclickHandler(this.state.radioBtnState);
    // }

    // ____________________________________ render ____________________________________

    render() {
        return (
            <div className="container select-artist-title ">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-7">
                        <p className="text-center">{i18n.t('select.artisttitle.intro')}</p>

                        <Autocomplete
                            suggestions={this.props.autocompleteArray}
                            selectedState={this.props.selectedState}
                            onClick={this.props.onClick}
                            onApplyClick={this.props.onApplyClick}
                        />

                        {/* <Autocomplete suggestions={["Oranges", "Apples", "Banana", "Kiwi", "Mango"]} /> */}
                        {/* <SelectApplyBtn isdisabled={this.state.location === ''} onclick={(e) => this.onSubmitHandler()} /> */}
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(SelectArtistTitle);